import { render, staticRenderFns } from "./Limitaodingdan.vue?vue&type=template&id=7114bf0d&"
import script from "./Limitaodingdan.vue?vue&type=script&lang=js&"
export * from "./Limitaodingdan.vue?vue&type=script&lang=js&"
import style0 from "./Limitaodingdan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports